var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-activation-success"},[(_vm.getSuccessIdent === 'videoIdentWeb')?_c('div',{staticClass:"videoIdentWeb"},[_c('SuccessContent',{attrs:{"slotData":{
        SuccessUrl: _vm.getSuccessUrl,
        linkEnabled: _vm.getClassUrl(),
        msisdn: _vm.msisdn
      },"type":"videoIdent"}}),_c('SuccessContent',{attrs:{"slotData":{
        SuccessUrl: _vm.getSuccessUrl,
        linkEnabled: _vm.getClassUrl(),
        msisdn: _vm.msisdn
      },"type":"videoIdentPost"}}),_c('SuccessContent',{attrs:{"slotData":{
        SuccessUrl: _vm.getSuccessUrl,
        linkEnabled: _vm.getClassUrl(),
        msisdn: _vm.msisdn
      },"type":"postIdent"}})],1):_vm._e(),(_vm.getSuccessIdent === 'videoIdentPost')?_c('div',{staticClass:"videoIdentPost"},[_c('SuccessContent',{attrs:{"slotData":{
        SuccessUrl: _vm.getSuccessUrl,
        linkEnabled: _vm.getClassUrl(),
        msisdn: _vm.msisdn
      },"type":"videoIdentPost"}})],1):_vm._e(),(_vm.getSuccessIdent === 'postIdent')?_c('div',{staticClass:"postIdent"},[_c('SuccessContent',{attrs:{"slotData":{
        SuccessUrl: _vm.getSuccessUrl,
        linkEnabled: _vm.getClassUrl(),
        msisdn: _vm.msisdn
      },"type":"postIdent"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }